import { render, staticRenderFns } from "./advertisingPlace.vue?vue&type=template&id=5f15f223&scoped=true&"
import script from "./advertisingPlace.vue?vue&type=script&lang=js&"
export * from "./advertisingPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f15f223",
  null
  
)

export default component.exports